import { render } from "./ModalAlerta.vue?vue&type=template&id=597635db"
import script from "./ModalAlerta.vue?vue&type=script&lang=js"
export * from "./ModalAlerta.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__